import Link from 'next/link'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { gradientBtn } from '@/lib/ui-classes'
import { useUserStore } from '@/store/user'
import { useConfigStore } from '@/store/config'
import { canShowRegisterEntry } from '@/utils/register-visibility'

const BEIAN_URL = 'https://beian.miit.gov.cn/'

export function HomeCtaFooter() {
  const isAuthenticated = useUserStore(state => state.isAuthenticated)
  const config = useConfigStore(state => state.config)
  const tcpRecordNumber = config?.tcp_record_number?.trim()
  const showRegisterEntry = canShowRegisterEntry(config)

  return (
    <section
      className={`relative overflow-hidden bg-black px-4 pt-16 text-center sm:px-6 ${tcpRecordNumber ? 'pb-8' : 'pb-16'}`}
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(7,244,242,0.12),_transparent_45%)] opacity-80" />

      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative z-10 mx-auto max-w-4xl space-y-8"
      >
        <h2 className="text-3xl font-semibold text-white md:text-5xl">
          让灵感不再停留在剧本阶段
          <span className="mt-4 block bg-gradient-to-r from-[#07F4F2] to-[#C1FAB8] bg-clip-text text-transparent">
            立即开始你的第一部 AI 漫剧
          </span>
        </h2>

        <p className="mx-auto max-w-2xl text-lg leading-8 text-zinc-400">
          用同一套系统管理内容生产、素材资产与成片输出，把漫剧创作真正做成可持续流程。
        </p>

        <div className="pt-2">
          <Link href={isAuthenticated ? '/projects' : (showRegisterEntry ? '/auth/register' : '/auth/login')}>
            <Button size="lg" className={`${gradientBtn} h-16 px-10 text-lg sm:px-12 sm:text-xl`}>
              {isAuthenticated
                ? '进入项目工作台'
                : (showRegisterEntry ? '立即注册，开始创作' : '立即登录，开始创作')}
              <ArrowRight className="ml-2 h-5 w-5 sm:h-6 sm:w-6" />
            </Button>
          </Link>
        </div>
      </motion.div>

      {tcpRecordNumber ? (
        <a
          href={BEIAN_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="relative z-10 mt-14 block text-xs text-zinc-600 transition-colors hover:text-zinc-400"
        >
          {tcpRecordNumber}
        </a>
      ) : null}
    </section>
  )
}
